import type { ReactNode } from 'react';

import { Button } from '../buttons/Button';
import { Post } from '../post/Post';

import { FullScreenFrame } from './FullScreenFrame';

import styles from './fullscreen-error.module.scss';

export type FullScreenErrorProps = {
  headline: string;
  message?: ReactNode;
  onRetry: () => void;
  retryLabel: string;
  onLogout?: () => void;
  logoutLabel?: string;
  showLogo?: boolean;
  children?: ReactNode;
};

export function FullScreenError({
  headline,
  message,
  onRetry,
  retryLabel,
  onLogout,
  logoutLabel,
  showLogo,
  children,
}: FullScreenErrorProps) {
  return (
    <FullScreenFrame showLogo={showLogo}>
      <Post>
        {children}
        <h1>{headline}</h1>
        {message && <p>{message}</p>}
        <div data-right className={styles['button-container']}>
          <Button onClick={onRetry}>{retryLabel}</Button>
          {onLogout && (
            <Button variant="secondary" onClick={onLogout}>
              {logoutLabel}
            </Button>
          )}
        </div>
      </Post>
    </FullScreenFrame>
  );
}
